import { render, staticRenderFns } from "./ViewGenre.vue?vue&type=template&id=d52cadea"
import script from "./ViewGenre.vue?vue&type=script&lang=js"
export * from "./ViewGenre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports